import styled from "styled-components";

export const LoadingScale = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: center;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999 !important;
`;
